import { render, staticRenderFns } from "./SubfactorCard.vue?vue&type=template&id=024da706&scoped=true&"
import script from "./SubfactorCard.vue?vue&type=script&lang=js&"
export * from "./SubfactorCard.vue?vue&type=script&lang=js&"
import style0 from "./SubfactorCard.vue?vue&type=style&index=0&id=024da706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024da706",
  null
  
)

export default component.exports